import { useMemo } from 'react';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useActivationId } from '@atlassian/jira-tenant-context-controller/src/components/activation-id/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { JiraWorkspaceAri } from '@atlassian/ari/jira/workspace';
import { IdentityUserAri } from '@atlassian/ari/identity/user';

interface UseNetworkStorageParamsReturnType {
	activationId: string;
	entityAri: string;
	ownerAri: string;
	siteId: string;
}

export function useNetworkStorageParams(): UseNetworkStorageParamsReturnType {
	const cloudId = useCloudId();
	const activationId = useActivationId();
	const ownerId = useAccountId();

	const siteId = cloudId;
	const entityAri = JiraWorkspaceAri.create({ siteId, activationId }).toString();
	const ownerAri = (ownerId && IdentityUserAri.create({ userId: ownerId }).toString()) || '';

	return useMemo(
		() => ({ activationId, entityAri, ownerAri, siteId }),
		[activationId, entityAri, ownerAri, siteId],
	);
}
